import { axiosInstance } from './apiAxiosInstance';

export const authService = {
  async checkUserAuthentication(): Promise<any> {
    return axiosInstance.get('/api/v1/auth/me');
  },

  async login(returnUrl: string): Promise<any> {
    return axiosInstance.get(`/api/v1/auth/login?returnUrl=${returnUrl}`);
  }
};